'use client';

import React from 'react';
import { useIntl } from 'react-intl';
import { Notification } from '@packages/shared/src/ui/Notification/Notification';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useInstallmentCalculatorTracking } from '../../components/Tracking/hooks/useInstallmentCalculatorTracking/useInstallmentCalculatorTracking';

/**
 * info call to action atom
 *
 * atom to display information about the installment process
 *
 * */
export const InfoCallToAction = () => {
  const { formatMessage } = useIntl();
  const [showNotification, setShowNotification] = React.useState(false);

  const { trackGlycerinImageClick } = useInstallmentCalculatorTracking();

  const handleClick = () => {
    trackGlycerinImageClick();
    setShowNotification(true);
  };

  const handleClose = () => {
    setShowNotification(false);
  };

  return showNotification ? (
    <Notification severity="info" onClose={handleClose}>
      {formatMessage({
        id: 'ic-infoCallToAction-infotext',
        defaultMessage:
          'Die Ratenhöhe und die Laufzeit liegen in deinen Händen. Durch einfaches Anpassen der Laufzeit findest du deine persönliche Wunschrate.',
      })}
    </Notification>
  ) : (
    <Button variant="icon-flat" className="rounded-full" onClick={handleClick}>
      <span className="text-color-info icon-emp-info-filled size-2.5" />
    </Button>
  );
};
